export interface CodeEdit {
  readonly next: string;
  readonly focus: number;
}

export const onlyDigits = (value: string): string => value.replace(/\D/g, '');

const lastBox = (length: number): number => length - 1;

const landingIndex = (value: string, index: number): number => Math.min(index, value.length);

export const pasteAt = (value: string, index: number, text: string, length: number): CodeEdit | null => {
  const digits = onlyDigits(text);
  if (digits === '') return null;
  const next = (value.slice(0, landingIndex(value, index)) + digits).slice(0, length);
  return { next, focus: Math.min(next.length, lastBox(length)) };
};

const replacedDigit = (held: string | undefined, digits: string): string | null => {
  if (held === undefined || digits.length !== 2 || !digits.includes(held)) return null;
  return digits[0] === held ? digits[1] : digits[0];
};

const typeOne = (value: string, index: number, digit: string, length: number): CodeEdit => {
  const at = landingIndex(value, index);
  const next = (value.slice(0, at) + digit + value.slice(at + 1)).slice(0, length);
  return { next, focus: Math.min(at + 1, lastBox(length)) };
};

export const typeAt = (value: string, index: number, raw: string, length: number): CodeEdit | null => {
  const digits = onlyDigits(raw);
  if (digits === '') return null;
  if (digits.length === 1) return typeOne(value, index, digits, length);
  const replacement = replacedDigit(value[index], digits);
  if (replacement !== null) return typeOne(value, index, replacement, length);
  return pasteAt(value, index, digits, length);
};

export const backspaceAt = (value: string, index: number): CodeEdit | null => {
  if (value[index]) return { next: value.slice(0, index) + value.slice(index + 1), focus: index };
  if (index === 0) return null;
  return { next: value.slice(0, index - 1), focus: index - 1 };
};
